export enum CONTACTS {
    SUPPORT_EMAIL = 'support@tinda.ru',
}